import React, { useState, useEffect, createContext } from 'react'
import { useTranslation } from "react-i18next"; // 1.1 i18n
import { ADD_RESIDENTS_ARRAY } from '../stores/reducer_residentsArray';
import { useDispatch, useSelector } from 'react-redux';
import ApiGo from '../actions/ApiGo';
import { ADD_USERS_ARRAY } from '../stores/reducer_usersArray';
import { ADD_ALL_MAC_ALERTS_SETTING_ARRAY } from '../stores/reducer_padsArray';
import { ADD_BEDS_ARRAY } from '../stores/reducer_beds';
import DeviceHandler from './epmed/EpMobile/DeviceHandler';
import { NavBarMobile } from './navBar/NavBarMobile';
import DashboardEP from './dashboard/DashboardEP';
import { ADD_BEDSTEADS_ARRAY } from '../stores/reducer_bedsteadsArray';
import ConfigHandler from '../actions/ConfigHandler';
import Dashboard from './dashboard/Dashboard';
import Residents from './residents/Residents';
import User from './user/User';
import { BedsteadManagement } from './epmed/BedsteadManagement';
import Pad from './pad/Pad';
import Mos from '../actions/Mos';
import ResidentMobile from './residents/ResidentMobile';

const date = new Date();
const year = date.getFullYear()
const markC = "©"

export const CTXHide = createContext()

export const LayoutMobile =()=>{
    const { t, i18n } = useTranslation(); // 1.2 i18n
    const [returnSearchResults, setReturnSearchResults] = useState("");
    const mos = Mos()
    // account role base
    let currentAccount = localStorage.getItem("currentAccount")
    const accountRole = currentAccount!==null? JSON.parse(localStorage.getItem(currentAccount)).role:null
    // for addbtn
    const [navIndex, setNavIndex] = useState(true);
    // ------------------ redux ------------------
    const LayoutPage = useSelector(state=>state.store_layout)
    const dispatch = useDispatch()
    const [leave, setLeave] = useState(false);

    useEffect(() => {
        ApiGo.getBed()
        .then(res=>{dispatch(ADD_BEDS_ARRAY(res.beds) || [])})
        .catch(err=>{console.log(err);})

        ApiGo.getResidents()
        .then(res=>{
            dispatch(ADD_RESIDENTS_ARRAY(res))
        })
        .catch(err=>{console.log(err);})

        ApiGo.getUsers()
        .then(res=>{
            dispatch(ADD_USERS_ARRAY(res.users))
        })
        .catch(err=>{console.log(err);})

        ApiGo.getAll_mac_alert_setting()
        .then(res=>{dispatch(ADD_ALL_MAC_ALERTS_SETTING_ARRAY(res))})
        .catch(err=>{console.log(err);})

        ApiGo.getBedsteads()
        .then(res=>{ dispatch(ADD_BEDSTEADS_ARRAY(res)) })
        .catch(err=>{console.log(err);})

    }, [dispatch]);
    // ------------------ redux ------------------

    function pageHandler(){
        let curCom = ConfigHandler.layoutControl().layoutArr[LayoutPage.currentPage][1]
        switch (curCom){
            case 'NAV_BAR.FRONT_PAGE':
                let com = ConfigHandler.isShowEP()? <DashboardEP  mos={mos}/>:<Dashboard mos={mos}/>
                return {
                    component: com,
                    addPageBtn: true,
                    addPageName: '床位排序',
                    i18nSearchResults:''
                }
            case 'NAV_BAR.RESIDENTS':
                return {
                    component:<ResidentMobile/>,
                    addPageBtn: true,
                    addPageName: t("GLOBAL.ADD_RESIDENTS"),
                    i18nSearchResults:t("GLOBAL.SEARCH_RESULTS") +" "+returnSearchResults+" "+ t("GLOBAL.PEOPLE")
                }
            case 'NAV_BAR.USERS':
                return {
                    component:<User setReturnData={setReturnSearchResults} />,
                    addPageBtn: true,
                    addPageName: t("GLOBAL.ADD_USERS"),
                    i18nSearchResults:t("GLOBAL.SEARCH_RESULTS") +" "+returnSearchResults+" "+ t("GLOBAL.PEOPLE")
                }
            case 'NAV_BAR.BLOOD_PRESSURE':
                return {
                    component:<DeviceHandler setReturnData={setReturnSearchResults} />,
                    addPageBtn: true,
                    addPageName: t("GLOBAL.ADD_BLOODPRESSURE"),
                    i18nSearchResults:t("GLOBAL.SEARCH_RESULTS") +" "+ returnSearchResults +" "+ t("GLOBAL.BED")
                }
            case 'NAV_BAR.BEDSTEAD':
                return {
                    component:<BedsteadManagement setReturnData={setReturnSearchResults} />,
                    addPageBtn: true,
                    addPageName: t("GLOBAL.ADD_BEDSTEADS"),
                    i18nSearchResults:t("GLOBAL.SEARCH_RESULTS") +" "+ returnSearchResults +" "+ t("GLOBAL.BED")
                }
            case 'NAV_BAR.PADS':
                return {
                    component:<Pad setReturnData={setReturnSearchResults} />,
                    addPageBtn: true,
                    addPageName: t("GLOBAL.ADD_PADS"),
                    i18nSearchResults:t("GLOBAL.SEARCH_RESULTS") +" "+ returnSearchResults +" "+ t("GLOBAL.BED")
                }
            default:
                return {
                    component:com,
                    addPageBtn: false,
                    addPageName: '',
                    i18nSearchResults:''
                }
        }
    }

    return(
        <div className="layout fx-d-c fx-nsbn">
            <div className="w-100 h-100">
                <div className='w-100'>
                    {/* NavBar + 空白 */}
                    <NavBarMobile setNavIndex={setNavIndex}/>
                </div>
                <div className="page-frame">{pageHandler().component}</div>
            </div>
            {/* <div className="fx-ccc font-ml">{markC} {year} {t("GLOBAL.BRAND")}</div> */}
        </div>
    );

}